import React, { useState } from "react";


// Props definition for the toggle switch
interface ToggleSwitchProps {
  onlineText: string; // Text for the online state
  offlineText: string; // Text for the offline state
  onlineColor: string; // Background color for online state
  offlineColor: string; // Background color for offline state
  initialState?: boolean; // Optional initial state
  onToggle?: (state: boolean) => void; // Callback for state changes
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  onlineText,
  offlineText,
  onlineColor,
  offlineColor,
  initialState = false,
  onToggle,
}) => {
  // State to manage toggle
  const [isOnline, setIsOnline] = useState<boolean>(initialState);

  // Handle toggle change
  const handleToggle = () => {
    const newState = !isOnline;
    setIsOnline(newState);
    if (onToggle) {
      onToggle(newState); // Notify parent component
    }
  };

  return (
    <div className={`toggle-switch ${isOnline ? 'on' : 'off'}`}>
      <input
        type="checkbox"
        className="toggle-switch-checkbox"
        id="toggle-switch"
        checked={isOnline}
        onChange={handleToggle}
      />
      <label
        className="toggle-switch-label"
        htmlFor="toggle-switch"
        style={{
          backgroundColor: isOnline ? onlineColor : offlineColor,
        }}
      >
        <span className="toggle-switch-inner">
          {isOnline ? onlineText : offlineText}
        </span>
        <span className="toggle-switch-switch" />
      </label>
    </div>
  );
};

export default ToggleSwitch;
